import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
`;

export const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  cursor: pointer;

  padding: 10px;
  border-radius: 5px;

  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);

  ${({ selected, theme }) =>
    selected &&
    `
    outline: 2px solid ${theme.colors.primary.cetaceanBlue};
  `}

  svg {
    width: 30px;
    height: 30px;
  }
`;
